import { render, staticRenderFns } from "./questionUploadpage.vue?vue&type=template&id=c82ab9b6&scoped=true&"
import script from "./questionUploadpage.vue?vue&type=script&lang=js&"
export * from "./questionUploadpage.vue?vue&type=script&lang=js&"
import style0 from "../../static/Modal.sass?vue&type=style&index=0&lang=sass&rel=stylesheet%2Fsass&"
import style1 from "../../static/Loading.sass?vue&type=style&index=1&lang=sass&rel=stylesheet%2Fsass&"
import style2 from "../expool/expool.sass?vue&type=style&index=2&id=c82ab9b6&lang=sass&rel=stylesheet%2Fsass&scoped=true&"
import style3 from "./questionUploadpage.vue?vue&type=style&index=3&id=c82ab9b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82ab9b6",
  null
  
)

export default component.exports